module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nuBZgP/Images/cover.jpg?1685327423025",
      "alt": "This image is the cover for the book A Fire in the Heart, Archangel Chronicles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Fire in the Heart, Archangel Chronicles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to A Shot in the Dark"), _c('br'), _vm._v("Archangel Chronicles: Book Eight")])])]), _c('p', [_vm._v("Emotions run high as Archangels Gabriel and Michael join forces with their Brotherhood and their old allies, the Archdemon Guild of Glass Knives, to fight the new forces of terror that threaten the world. Loyalties are tested and loves are strained, some to breaking point.")]), _vm._v(" "), _c('p', [_vm._v("This time, the threat is from a new direction, and no demons or rogue angels are involved. As their quest for victory continues, Gabriel and Michael and their allies find themselves drawn into the murky world of crime and speculations where who lives and who dies is determined by cash.")]), _vm._v(" "), _c('p', [_vm._v("As all seems hopeless, their every measure failing, Gabriel and Michael must comfort one another and their loved ones. But even as they do all they can to save the world, can they save their love?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L.J. LaBarthe\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0